import styles from './Header.module.scss';

export function Header() {
  return <header hidden={true} className={styles.header}></header>;
}
